export default __webpack_public_path__ + "static/media/museo_oro.5e876cbd.jpeg";